import React, { useEffect } from 'react'
import { Select } from '@deal/components'
import styles from './styles.css'
import { ListPathFlowQuestionProps } from '../'

const DropDown: React.SFC<ListPathFlowQuestionProps> = ({
  question,
  display,
  onFieldValidityChanged,
  onFieldValueChanged
}) => {
  const handleUpdateValue = (dropdownValue: string) => {
    onFieldValueChanged({ value: dropdownValue })

    if (question.required) {
      if (!dropdownValue) {
        onFieldValidityChanged(false)
      } else {
        onFieldValidityChanged(true)
      }
    }
  }

  useEffect(() => {
    const defaultValue =
      question.listUserInput.value && question.listUserInput.value.length === 1
        ? question.listUserInput.value[0]
        : undefined

    if (defaultValue) {
      handleUpdateValue(defaultValue)
    }
  }, [])

  const defaultValue =
    question.listUserInput.value && question.listUserInput.value.length === 1
      ? question.listUserInput.value[0]
      : ''

  return (
    <div className={styles.container}>
      <Select
        display={display}
        label={question.internalName}
        labelHidden={true}
        name={question.internalName}
        defaultValue={defaultValue}
        onChange={ev => {
          handleUpdateValue(ev.target.value)
        }}
        options={[
          { value: '', label: 'Please select one...', disabled: true },
          ...question.choices.map(choice => ({
            label: choice.text ? choice.text.text : '',
            value: choice.value,
            disabled: false,
            selected: false
          }))
        ]}
      />
    </div>
  )
}

export default DropDown
